import { useEffect } from "react";
import { useWatch, useFormContext } from "react-hook-form";

export const FieldsCleaner = ({ watch, clear = [] }) => {
  const { resetField } = useFormContext();
  const watched = useWatch({ name: watch });

  useEffect(() => {
    if (watched) {
      clear.forEach((field) => resetField(field));
    }
  }, [watched, resetField]);

  return null;
};
